import React from "react";
import PropTypes from "prop-types";
import { Button } from "@material-ui/core";

import "./AutoSaveStatus.css";
var classNames = require("classnames");

const statuses = {
	LOADED:"Cambios guardados automáticamente",
	SUCCESS:"Cambios guardados automáticamente",
	ERROR:"Error al guardar los cambios",
	LOADING:"Guardando",
};
export default function AutoSaveStatus(props) {
	return (
		<div  className={classNames({ 
			"save-box":true,
			"failed-box": props.status.status==="ERROR", 
			"saving-box": props.status.status==="LOADING", 
			"saved-box":props.status.status==="LOADED" || props.status.status==="SUCCESS" })}>
			<div style={{display: "inline"}}>{props.statuses ? props.statuses[props.status.status]: statuses[props.status.status]}</div>
			{props.status.status==="ERROR"&&<div><div>{props.status.errorMsg}</div><button className="reintentar-button" onClick={props.save}>Reintentar</button></div>}
		</div>

	);
}